module.exports = __webpack_public_path__ + "img/pic5.ad83c0f5.png";